import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomCardCharts from "components/CustomCardCharts/CustomCardCharts";
import usePlandactionsTable from "components/RTPlanActions/usePlandactionsTable.js";
import { CustomSelect } from "components/Input/Index.js";
import { width } from "@mui/system";

const unitsData = [
  { name: "€", id: "euros" },
  { name: "CO2", id: "co2" },
  { name: "kWh", id: "kwh" },
];

export default function ActionPlansDashboard(props) {
  const { dashboard } = props;
  const [economyUnit, setEconomyUnit] = useState("euros");

  const {
    totalactionplans,
    newactionplans,
    finished,
    creation,
    creation_late,
    standby,
    standby_late,
    inprogress,
    inprogress_late,
    pending,
    pending_late,
    investment_projected,
    investment_real,
    investmentbydate,
    savings_projected_co2,
    savings_projected_euros,
    savings_projected_kwh,
    savings_real_co2,
    savings_real_euros,
    savings_real_kwh,
    savingsbydate_co2,
    savingsbydate_euros,
    savingsbydate_kwh,
  } = dashboard;

  const optionsAP = {
    chart: {
      type: "column",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: ["Création", "Approuvé", "En cours", "En pause", "Terminés"],
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
      stackLabels: {
        enabled: false,
        style: {
          fontWeight: "bold",
          color:
            // theme
            (Highcharts.defaultOptions.title.style &&
              Highcharts.defaultOptions.title.style.color) ||
            "gray",
        },
      },
    },
    legend: {
      align: "right",
      x: -30,
      verticalAlign: "top",
      y: 25,
      floating: false,
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || "white",
      borderColor: "#CCC",
      borderWidth: 1,
      shadow: false,
    },
    tooltip: {
      headerFormat: "<b>{point.x}</b><br/>",
      pointFormat: "{series.name}: {point.y}",
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: [
      {
        name: "Total",
        data: notLate(),
      },
      {
        name: "En retard",
        data: late(),
      },
    ],
  };

  const optionsInvestment = {
    accessibility: {
      description: "Image description",
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    yAxis: {
      title: {
        text: "€",
      },
    },
    xAxis: {
      type: "datetime",
    },
    tooltip: {
      crosshairs: true,
      shared: true,
      valueSuffix: "€",
      xDateFormat: "%A, %b %e",
    },

    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle",
    },

    plotOptions: {
      series: {
        label: {
          connectorAllowed: false,
        },
      },
    },

    series: [
      {
        name: "projeté",
        data: projected_bydate(investmentbydate || []),
      },
      {
        name: "réel",
        data: real_bydate(investmentbydate || []),
      },
    ],

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
            },
          },
        },
      ],
    },
  };

  const optionsEconomy = {
    accessibility: {
      description: "Image description",
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    yAxis: {
      title: {
        text: findNameOfUnitById(economyUnit),
      },
    },

    xAxis: {
      type: "datetime",
    },
    tooltip: {
      crosshairs: true,
      shared: true,
      valueSuffix: ` ${findNameOfUnitById(economyUnit)}`,
      xDateFormat: "%A, %b %e",
    },

    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle",
    },

    plotOptions: {
      series: {
        label: {
          connectorAllowed: false,
        },
      },
    },

    series: [
      {
        name: "projeté",
        data: projected_bydate(getEconomyData()),
      },
      {
        name: "réel",
        data: real_bydate(getEconomyData()),
      },
    ],

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
            },
          },
        },
      ],
    },
  };

  const handleUnitChange = (e) => {
    const { name, value } = e.target;
    console.log(e.target);
    setEconomyUnit(value);
  };

  function subtractArray(arr1, arr2) {
    return arr2.map(function (el, i) {
      return Math.abs(el - arr1[i]);
    });
  }

  function notLate() {
    let data = [creation, standby, inprogress, pending];
    let dataLate = [creation_late, standby_late, inprogress_late, pending_late];

    return [...subtractArray(dataLate, data), finished];
  }
  function late() {
    let dataLate = [creation_late, standby_late, inprogress_late, pending_late];

    return dataLate;
  }

  function projected_bydate(data) {
    let projectedArray = [];
    data.map(([date, projected]) => projectedArray.push([date, projected]));

    return projectedArray;
  }

  function real_bydate(data) {
    let realArray = [];
    data.map(([date, projected, real]) => realArray.push([date, real]));

    return realArray;
  }

  function savingsProjected() {
    if (economyUnit === "co2") {
      return savings_projected_co2;
    } else if (economyUnit === "euros") {
      return savings_projected_euros;
    } else {
      return savings_projected_kwh;
    }
  }

  function savingsReal() {
    if (economyUnit === "co2") {
      return savings_real_co2;
    } else if (economyUnit === "euros") {
      return savings_real_euros;
    } else {
      return savings_real_kwh;
    }
  }

  function findNameOfUnitById(unit) {
    return unitsData.find((x) => x.id === unit).name;
  }

  function getEconomyData() {
    if (economyUnit === "co2") {
      return savingsbydate_co2 || [];
    } else if (economyUnit === "euros") {
      return savingsbydate_euros || [];
    } else {
      return savingsbydate_kwh || [];
    }
  }

  return (
    <>
      <GridContainer style={{width:'100%'}}>
        <GridItem xs={12} sm={12} md={6} lg={4} xl={4}>
          <CustomCardCharts
            cardTitle="Total plan d'actions"
            cardNumber={totalactionplans}
            dataTitle="Statut Plan d'action (dont en retard)"
            dataName0="Nouveaux (ce mois-ci)"
            data0result={newactionplans}
            dataName1="Création"
            data1result={`${creation || "0"} (${creation_late || "0"})`}
            dataName2="Approuvé"
            data2result={`${standby || "0"} (${standby_late || "0"})`}
            dataName3="En cours"
            data3result={`${inprogress || "0"} (${inprogress_late || "0"})`}
            dataName4="En pause"
            data4result={`${pending || "0"} (${pending_late || "0"})`}
            dataName5="Terminées"
            data5result={finished || "0"}
            graphicName={""}
            graphic={
              <HighchartsReact
                containerProps={{
                  style: { height: "14.3rem", width: "100%" },
                }}
                highcharts={Highcharts}
                options={optionsAP}
              />
            }
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={4} xl={4}>
          <CustomCardCharts
            cardTitle="Investissements"
            dataName1="Investissements projetés"
            data1result={`${investment_projected || "0"} €`}
            dataName2="Investissements réels"
            data2result={`${investment_real || "0"} €`}
            graphicName={""}
            graphic={
              <HighchartsReact
                containerProps={{
                  style: { height: "20.8rem", width: "100%" },
                }}
                highcharts={Highcharts}
                options={optionsInvestment}
              />
            }
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={4} xl={4}>
          <CustomCardCharts
            switchButton={
              <CustomSelect
                selectValue={economyUnit}
                handleSelectValueChange={handleUnitChange}
                data={unitsData}
                name="units"
              />
            }
            cardTitle2="Economies"
            dataName1="Economies estimées"
            data1result={`${savingsProjected() || "0"} ${
              findNameOfUnitById(economyUnit) || "0"
            }`}
            dataName2="Economies réelles"
            data2result={`${savingsReal() || "0"} ${
              findNameOfUnitById(economyUnit) || "0"
            }`}
            graphicName={""}
            graphic={
              <HighchartsReact
                containerProps={{
                  style: { height: "19.3rem", width: "100%" },
                }}
                highcharts={Highcharts}
                options={optionsEconomy}
              />
            }
          />
        </GridItem>
      </GridContainer>
    </>
  );
}
